import {navigate} from "gatsby-plugin-intl";
import {LOGOUT_URL} from "../utils/constants/constants";
import {WSInstance} from "./api/axios_config";
import {getToken} from "./api/requests";
import jwt_decode from "jwt-decode";

export const isBrowser = () => typeof window !== "undefined";

const USER_KEY = "civica-user";
const JWT_KEY = `token`;

const decodeJwtToken = (token, from, config) => {
  if(token == null || token === 'undefined'){
    //console.log(from+ " - CANNOT DECODE JWT TOKEN NULL: Token:"+token);
    return null;
  }
  try {
    return config ? jwt_decode(token, config) : jwt_decode(token);  
  } catch (error) {
    //console.error(from+ " - ERROR TO DECODE JWT TOKEN: " + error.message + "\n Token: "+token);
    return null;
  } 
}

export const isLoggedIn = () => {
  if (!isBrowser()) return false;
  const token = window.localStorage.getItem("token");
  if (!!token) {
    let isExpired = false;
    const decodedToken = decodeJwtToken(token, "isLoggedIn", { complete: true });
    if(decodedToken == null){
      return false;
    }    
    const dateNow = new Date();
    if (decodedToken.exp * 1000 < dateNow.getTime()) {
      isExpired = true;
    }
    return !isExpired && !!decodedToken.displayName;
  } else {
    return false;
  }
};

export const login = async () => {
  //console.log("login - START");
  if (!isBrowser()) {
    return;
  }
  if (!isLoggedIn()) {
    try {
      await getAndStoreToken();
    } catch (error) {
      console.error("login - ERROR: ", error);
      navigate(`/`);
    }
  }
  //console.log("login - SUCCESS"); 
  navigate(`/`);
};

export const logout = () => {
  //console.log("logout - START"); 
  try {
    window.localStorage.removeItem("token");
    WSInstance.get(LOGOUT_URL, { withCredentials: true });
    //console.log("logout - SUCCESS"); 
    navigate(`/login`);
  } catch (error) {
    console.error("logout - ERROR: ", error);    
  }
};

export const getAndStoreToken = async () => {
  //console.log("getAndStoreToken - START");
  if (!isBrowser()) return; 
  try {
    let data = await getToken();
    //console.log("getAndStoreToken - data: ", data); 
    window.localStorage.setItem("token", data.data["token"]);
    //console.log("getAndStoreToken - SUCCESS"); 
  } catch (error) {
    console.error("getAndStoreToken - ERROR: ", error);
  }
};


export function currentToken() {
  //console.log("currentToken - START");
  if (typeof window === `undefined`) return undefined;
  return localStorage.getItem(JWT_KEY);
}



export const getUser = () => {
  if (isBrowser() && window.localStorage.getItem(USER_KEY)) {
    try {
      return JSON.parse(window.localStorage.getItem(USER_KEY));
    } catch (err) {}
  }
  return {};
};


export const containsRole = (roles) => {
  let containsRole = false;
  if (roles) {
    const userRoles = getUserRole();
    roles.forEach((role, index) => {
      if (userRoles.indexOf(role) !== -1) {
        containsRole = true;
        return false;
      }
    });
  }
  return containsRole;
};

export const getDisplayName = () => {
  const tokenDetails = getTokenDetails();
  return !!tokenDetails ? tokenDetails.displayName : "";  
};


export const getTokenDetails = () => {
  if (typeof window === `undefined`) return {};
  const token = window.localStorage.getItem("token");
  let decodedToken = decodeJwtToken(token, "getTokenDetails");
  return decodedToken ?  decodedToken : null;
};

export const getUserRole = () => {
  // mock set token to be deleted
  let token = currentToken();
  let decodedToken = decodeJwtToken(token, "getUserRole");
  return decodedToken ?  decodedToken.authorities : [];
};

export const getAcademicId = () => {
  // mock set token to be deleted
  let token = currentToken();
  let decodedToken = decodeJwtToken(token, "getAcademicId");
  return decodedToken ?  decodedToken.academicId : [];
};

export const getUniversityId = () => {
  let token = currentToken();
  let decodedToken = decodeJwtToken(token, "getUniversityId");
  return decodedToken ?  decodedToken.universityId : [];
};